import { render, staticRenderFns } from "./RegisterIdenCard.vue?vue&type=template&id=3f72220c&scoped=true"
import script from "./RegisterIdenCard.vue?vue&type=script&lang=js"
export * from "./RegisterIdenCard.vue?vue&type=script&lang=js"
import style0 from "./RegisterIdenCard.vue?vue&type=style&index=0&id=3f72220c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f72220c",
  null
  
)

export default component.exports